import React from "react";
import { Helmet } from "react-helmet-async";
import "./OTGuidelines.css";

const guidelines = [
  {
    icon: "💡",
    title: "Advice & Quotation",
    desc: "Expert consultation from concept to execution ensuring NABH compliance, cost efficiency and optimized modular OT planning.",
  },
  {
    icon: "📐",
    title: "Planning",
    list: [
      "Preparation Room",
      "Modular Operation Theatre",
      "Recovery Room",
      "Clean & Dirty Corridors",
    ],
    desc: "Proper zoning, workflow management and pressure-controlled sterile air systems.",
  },
  {
    icon: "🏥",
    title: "Design",
    desc: "Customized OT layouts built for workflow efficiency, infection control and advanced laminar airflow systems.",
  },
  {
    icon: "⚙️",
    title: "Production",
    list: [
      "Laser Cutting & CNC Machines",
      "Automated Manufacturing",
      "Robotic Precision Production",
    ],
    desc: "Advanced in-house production ensuring consistency, precision and durability.",
  },
  {
    icon: "📋",
    title: "Project Management",
    desc: "End-to-end project execution with strict timelines, quality checks and NABH compliance.",
  },
];

function OTGuidelines() {
  return (
    <div className="ot-guidelines-page">
      <Helmet>
        <title>
          NABH Operation Theatre Guidelines | Modular OT Planning India | WEMS
        </title>

        <meta
          name="description"
          content="Complete NABH-compliant operation theatre guidelines including modular OT planning, design, production and project management by WEMS India."
        />

        <meta
          name="keywords"
          content="NABH OT guidelines, modular OT planning India, operation theatre standards, laminar airflow OT, modular operation theatre"
        />

        <link
          rel="canonical"
          href="https://www.wellnessmodularot.com/ot-guidelines"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="NABH Operation Theatre Guidelines | WEMS"
        />
        <meta
          property="og:description"
          content="Complete modular OT planning and NABH operation theatre guidelines by WEMS India."
        />
        <meta
          property="og:url"
          content="https://www.wellnessmodularot.com/ot-guidelines"
        />
        <meta property="og:type" content="website" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "NABH Operation Theatre Guidelines",
            description:
              "Complete NABH-compliant modular OT guidelines, planning and design.",
            url: "https://www.wellnessmodularot.com/ot-guidelines",
          })}
        </script>
      </Helmet>

      <span className="seo-hidden">
        NABH OT guidelines India, modular operation theatre design,
        laminar airflow OT systems, hospital OT planning by WEMS
      </span>

      {/* HERO */}
      <section className="ot-hero">
        <span className="ot-tag">NABH & OT Standards</span>
        <h1>NABH-Compliant Operation Theatre Guidelines</h1>
        <p>
          Complete guidance for planning, designing and executing modular
          operation theatres with NABH compliance, infection control and
          advanced sterile air systems.
        </p>
      </section>

      {/* CARDS */}
      <section className="ot-container">
        {guidelines.map((item, i) => (
          <div className="ot-card" key={i}>
            <div className="ot-icon">{item.icon}</div>

            <h2>{item.title}</h2>

            {item.list && (
              <ul>
                {item.list.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
            )}

            <p>{item.desc}</p>
          </div>
        ))}
      </section>

      {/* EXTRA CONTENT */}
      <section className="ot-info">
        <h2>Key NABH Requirements for Modular OT</h2>
        <p>
          NABH-compliant modular operation theatres require controlled sterile
          environments, HEPA filtration, positive pressure air systems,
          seamless wall panels, clean zoning, scrub stations and proper
          infection control infrastructure.
        </p>
      </section>

      {/* CTA */}
      <section className="ot-cta">
        <h2>Need NABH Compliant Modular OT Solutions?</h2>
        <p>
          WEMS provides complete turnkey modular OT planning, manufacturing and
          installation across India.
        </p>
        <a href="/contact-modular-ot">Get Consultation →</a>
      </section>
    </div>
  );
}

export default OTGuidelines;